import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';
import { Session } from 'services';
import httpClient from 'utils/httpClient';

const START_CLASS = (id: Number) => `/v2/teacher/unit/${id}/start`;

export type startClassBody = {
  id: number;
};

export type ConfirmSessionResponse = {
  session: Session;
};

export const startClass = ({ id }: startClassBody) => {
  let params = {};

  return httpClient.post<ConfirmSessionResponse>(START_CLASS(id), params);
};

export const useStartClass = (
  opts?: UseMutationOptions<
    AxiosResponse<ConfirmSessionResponse>,
    AxiosError<any>,
    startClassBody
  >,
) =>
  useMutation<
    AxiosResponse<ConfirmSessionResponse>,
    AxiosError<any>,
    startClassBody
  >(startClass, opts);
